import React from 'react'
import { Helmet } from 'react-helmet-async'
import "./contactus.css"
function Contactus() {
  return (
    <div>
      <Helmet>
        <title>Contact Us - Enteeon</title>
        <meta name="description" content="Get in touch with Enteeon. Reach out via email, phone, or visit our address in VelammaValasu, Sankari, Salem, Tamil Nadu." />
        <meta name="keywords" content="contact enteeon, get in touch, email, phone, address, salem tamil nadu, enteeon contact" />
        <meta property="og:title" content="Contact Us - Enteeon" />
        <meta property="og:description" content="Get in touch with Enteeon. Reach out via email, phone, or visit our address in VelammaValasu, Sankari, Salem, Tamil Nadu." />
        <meta property="og:image" content="/enteeon_logo.png" />
        <meta property="og:url" content="https://enteeon.com/contact" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact Us - Enteeon" />
        <meta name="twitter:description" content="Get in touch with Enteeon. Reach out via email, phone, or visit our address in VelammaValasu, Sankari, Salem, Tamil Nadu." />
        <meta name="twitter:image" content="/enteeon_logo.png" />
      </Helmet>
        <div className="contact-section">
      <div className="container text-center py-4">
        <h2 className="text-muted fw-bold">Get in Touch.</h2>
        <ul className="list-unstyled text-start mx-auto contact-details">
          <li><strong>Email:</strong> enteeonhere@gmail.com</li>
          <li><strong>Phone:</strong> +91 88073-41866 </li>
          <li><strong>Address:</strong> VelammaValasu, Sankari, Salem, Tamil Nadu</li>
        </ul>
      </div>
      <div className="stay-connected text-white text-center py-3">
        <strong>Stay Connected:</strong> Follow us on social media for the latest updates, news, and innovations.
      </div>
    </div>
    </div>
  )
}

export default Contactus